// // import React from "react";
// // import CED from "../Assets/About/About/use.jpg";
// // import ZigZag from "../Assets/zigzag-w.png";
// // import AboutSection2 from "./AboutSection2";

// // const CreativeCoachLanding = () => {
// //   return (
// //     <>
// //       <div className="relative min-h-screen lg:h-[120vh] bg-[#f2efea] overflow-hidden">
// //         {/* Background Section */}
// //         <div className="absolute inset-0 left-0 w-full md:w-3/4 lg:w-2/3 bg-[#C59880] z-10 md:h-[90vh] lg:h-[95vh]" />

// //         {/* Content container */}
// //         <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 pt-3">
// //           {/* Image - Positioned at top for mobile/tablet */}
// //           <div className="relative lg:absolute lg:right-[180px] lg:top-[85px] w-[250px] sm:w-[350px] md:w-[400px] lg:w-[400px] h-[300px] sm:h-[400px] md:h-[450px] lg:h-[500px] mx-auto mb-8 lg:mb-0">
// //             <img
// //               src={CED}
// //               alt="Creative Coach"
// //               className="w-full h-full object-cover"
// //             />
// //           </div>
// //           {/* Decorative Zigzag */}
// //           <div className="absolute top-[250px] sm:top-[300px] md:top-[350px] lg:top-[150px] left-[40%] sm:left-[45%] md:left-[50%] lg:left-[55%] z-20 mt-16 sm:mt-32 md:mt-72 rotate-45">
// //             <img
// //               src={ZigZag}
// //               alt="Decorative Zigzag"
// //               className="w-[80px] sm:w-[100px] md:w-[150px] lg:w-[200px] h-auto"
// //             />
// //           </div>

// //           {/* Text content */}
// //           <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center space-y-6 lg:space-y-0 pt-4 lg:pt-24 lg:mr-96">
// //             <div
// //               className="max-w-2xl text-center lg:text-left"
// //               style={{ fontFamily: "'Blacker Pro Display'" }}
// //             >
// //               <p className="text-sm uppercase tracking-widest lg:mr-96 text-[#2C2C2C] ">
// //                 Keyword master, ranking optimizer, backlink hunter,
// //                 <br />
// //                 <span
// //                   className="font-bold"
// //                   style={{ fontFamily: "'Blacker Pro Display'" }}
// //                 >
// //                   metrics driven
// //                 </span>
// //               </p>
// //               <div
// //                 className="text-center mt-6 sm:mt-8 lg:mt-12 lg:ml-0 xl:ml-40"
// //                 style={{ fontFamily: "'Blacker Pro Display'" }}
// //               >
// //                 <h1
// //                   className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-serif text-white mb-2 sm:mb-4"
// //                   style={{ fontFamily: "'Blacker Pro Display'" }}
// //                 >
// //                   Hi, I'm Laiba,
// //                 </h1>
// //                 <h2
// //                   className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-serif text-white leading-tight mb-6 sm:mb-8 lg:mb-12"
// //                   style={{ fontFamily: "'Blacker Pro Display'" }}
// //                 >
// //                   the heart behind
// //                   <br />
// //                   <span
// //                     className="text-4xl text-[#ebe8e5e0]"
// //                     style={{ fontFamily: "'Blacker Pro Display'" }}
// //                   >
// //                     Connect · Engage · Grow
// //                   </span>
// //                 </h2>
// //               </div>

// //               <p className="text-sm sm:text-md text-[#2B2B2B] w-full lg:w-[500px] font-semibold text-justify px-4 sm:px-0">
// //                 I started this journey with one goal: to help businesses like
// //                 yours thrive online and grow with ease. Social media can feel
// //                 overwhelming, but that’s where I step in! From crafting unique
// //                 content to managing platforms and building websites, my team and
// //                 I make sure your brand connects with the right people and
// //                 exceeds expectations.
// //               </p>
// //               <button
// //                 onClick={() => {
// //                   document
// //                     .getElementById("section2")
// //                     .scrollIntoView({ behavior: "smooth" });
// //                 }}
// //                 className="bg-[#704735] text-white px-4 sm:px-6 lg:px-8 py-2 sm:py-3 mt-6 sm:mt-7 text-xs sm:text-sm uppercase tracking-widest rounded-lg shadow-[5px_5px_15px_#5d392b] hover:shadow-[inset_5px_5px_15px_#5d392b,inset_-5px_-5px_15px_#855949] transition-all duration-300 ease-in-out"
// //               >
// //                 Learn More
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default CreativeCoachLanding;

// import React from "react";
// import CED from "../Assets/About/About/use.jpg";
// import ZigZag from "../Assets/zigzag-w.png";
// import Log from "../Assets/logo.png";
// const AboutHero = () => {
//   return (
//     <div className="relative min-h-screen bg-neutral-50 overflow-hidden">
//       {/* Main container */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
//         <div className="absolute top-0 right-0 w-60 h-60">
//           <svg
//             viewBox="0 0 240 240"
//             className="w-full h-full -translate-y-1/4 translate-x-1/4 -rotate-12"
//           >
//             {/* Decorative outer ring with gradient */}
//             <defs>
//               <linearGradient
//                 id="ring-gradient"
//                 x1="0%"
//                 y1="0%"
//                 x2="100%"
//                 y2="100%"
//               >
//                 <stop offset="0%" stopColor="#e5e5e5" />
//                 <stop offset="100%" stopColor="#d4d4d4" />
//               </linearGradient>
//             </defs>

//             {/* Main circle with subtle animation */}
//             <circle
//               cx="120"
//               cy="120"
//               r="118"
//               fill="transparent"
//               stroke="url(#ring-gradient)"
//               strokeWidth="2"
//               className="animate-pulse"
//             />

//             {/* Inner decorative circles */}
//             <circle
//               cx="120"
//               cy="120"
//               r="110"
//               fill="transparent"
//               stroke="#e5e5e5"
//               strokeWidth="1"
//               strokeDasharray="4 4"
//             />
//           </svg>

//           {/* Logo container */}
//           <div className="absolute inset-0 flex items-center justify-center">
//             <img
//               src={Log}
//               alt="Logo"
//               className="w-36 h-36 -mt-16 ml-16 object-contain rotate-45 transition-transform duration-300 hover:scale-105"
//             />
//           </div>
//         </div>
//         <div className="relative">
//           {/* Decorative curve */}
//           {/* <div className="absolute top-0 right-0 w-72 h-72 bg-transparent border-2 border-neutral-200 rounded-full -translate-y-1/4 translate-x-1/4" /> */}
//           {/* <div className="absolute top-0 right-0 w-60 h-60 bg-transparent border-2 border-neutral-200 rounded-full -translate-y-1/4 translate-x-1/4 flex items-center justify-center -rotate-12">
//             <img
//               src={Log}
//               alt="Logo"
//               className="w-36 h-36 object-contain rotate-45"
//             />
//           </div> */}

//           {/* Content grid */}
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             {/* Image section */}
//             <div className="relative">
//               <div className="bg-[#704735] opacity-80 absolute -top-8 -left-8 w-full h-full rounded-lg" />

//               <div className="relative">
//                 <img
//                   src={CED}
//                   alt="Workspace"
//                   className="rounded-lg shadow-xl w-full object-cover"
//                 />
//               </div>
//               <div className="absolute top-[250px] sm:top-[300px] md:top-[350px] lg:top-[150px] left-[40%] sm:left-[45%] md:left-[50%] lg:left-[80%] z-20 mt-16 sm:mt-32 md:mt-72 rotate-45">
//                 <img
//                   src={ZigZag}
//                   alt="Decorative Zigzag"
//                   className="w-[80px] sm:w-[100px] md:w-[150px] lg:w-[200px] h-auto"
//                 />
//               </div>
//             </div>

//             {/* Text content */}
//             <div className="lg:pl-12">
//               {/* <div className="space-y-4">
//                 <h1 className="text-7xl font-bold leading-tight">
//                   Hi, I'm{" "}
//                   <span className="relative">
//                     <span className="bg-gradient-to-r from-rose-400 to-orange-400 bg-clip-text text-transparent">
//                       Laiba
//                     </span>
//                     <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-rose-400 to-orange-400 rounded-full" />
//                   </span>
//                 </h1>

//                 <p className="text-3xl font-light text-neutral-300">
//                   The heart behind{" "}
//                   <span className="font-semibold bg-gradient-to-r from-purple-400 via-rose-400 to-orange-400 bg-clip-text text-transparent">
//                     Connect · Engage · Grow
//                   </span>
//                 </p>
//               </div>

//               <p className="text-lg text-neutral-300 leading-relaxed">
//                 I started this journey with one goal: to help businesses like
//                 yours thrive online and grow with ease. From crafting unique
//                 content to managing platforms and building websites, my team and
//                 I make your brand stand out.
//               </p> */}

//               <div
//                 className="max-w-2xl text-center lg:text-left"
//                 style={{ fontFamily: "'Blacker Pro Display'" }}
//               >
//                 <p className="text-sm uppercase tracking-widest lg:mr-96 text-[#2C2C2C] ">
//                   Keyword master, ranking optimizer, backlink hunter,
//                   <br />
//                   <span
//                     className="font-bold"
//                     style={{ fontFamily: "'Blacker Pro Display'" }}
//                   >
//                     metrics driven
//                   </span>
//                 </p>
//                 <div
//                   className="text-center mt-6 sm:mt-8 lg:mt-12 lg:ml-0 xl:ml-40"
//                   style={{ fontFamily: "'Blacker Pro Display'" }}
//                 >
//                   <h1
//                     className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-serif text-[#704735] mb-2 sm:mb-4"
//                     style={{ fontFamily: "'Blacker Pro Display'" }}
//                   >
//                     Hi, I'm Laiba,
//                   </h1>
//                   <h2
//                     className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-serif text-[#704735] leading-tight mb-6 sm:mb-8 lg:mb-12"
//                     style={{ fontFamily: "'Blacker Pro Display'" }}
//                   >
//                     the heart behind
//                     <br />
//                     <span
//                       className="text-4xl text-[#704735]"
//                       style={{ fontFamily: "'Blacker Pro Display'" }}
//                     >
//                       Connect · Engage · Grow
//                     </span>
//                   </h2>
//                 </div>

//                 <p className="text-sm sm:text-md text-[#161616] w-full lg:w-[500px] font-semibold text-justify px-4 sm:px-0 z-50">
//                   I started this journey with one goal: to help businesses like
//                   yours thrive online and grow with ease. Social media can feel
//                   overwhelming, but that’s where I step in! From crafting unique
//                   content to managing platforms and building websites, my team
//                   and I make sure your brand connects with the right people and
//                   exceeds expectations.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Background details */}
//       {/* <div className="absolute top-0 right-0 w-1/3 h-screen bg-amber-50/50 -skew-x-12 transform origin-top-right" /> */}
//     </div>
//   );
// };

// export default AboutHero;
// import React from "react";
// import CED from "../Assets/About/About/use.jpg";
// import ZigZag from "../Assets/zigzag-w.png";
// import AboutSection2 from "./AboutSection2";

// const CreativeCoachLanding = () => {
//   return (
//     <>
//       <div className="relative min-h-screen lg:h-[120vh] bg-[#f2efea] overflow-hidden">
//         {/* Background Section */}
//         <div className="absolute inset-0 left-0 w-full md:w-3/4 lg:w-2/3 bg-[#C59880] z-10 md:h-[90vh] lg:h-[95vh]" />

//         {/* Content container */}
//         <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 pt-3">
//           {/* Image - Positioned at top for mobile/tablet */}
//           <div className="relative lg:absolute lg:right-[180px] lg:top-[85px] w-[250px] sm:w-[350px] md:w-[400px] lg:w-[400px] h-[300px] sm:h-[400px] md:h-[450px] lg:h-[500px] mx-auto mb-8 lg:mb-0">
//             <img
//               src={CED}
//               alt="Creative Coach"
//               className="w-full h-full object-cover"
//             />
//           </div>
//           {/* Decorative Zigzag */}
//           <div className="absolute top-[250px] sm:top-[300px] md:top-[350px] lg:top-[150px] left-[40%] sm:left-[45%] md:left-[50%] lg:left-[55%] z-20 mt-16 sm:mt-32 md:mt-72 rotate-45">
//             <img
//               src={ZigZag}
//               alt="Decorative Zigzag"
//               className="w-[80px] sm:w-[100px] md:w-[150px] lg:w-[200px] h-auto"
//             />
//           </div>

//           {/* Text content */}
//           <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center space-y-6 lg:space-y-0 pt-4 lg:pt-24 lg:mr-96">
//             <div
//               className="max-w-2xl text-center lg:text-left"
//               style={{ fontFamily: "'Blacker Pro Display'" }}
//             >
//               <p className="text-sm uppercase tracking-widest lg:mr-96 text-[#2C2C2C] ">
//                 Keyword master, ranking optimizer, backlink hunter,
//                 <br />
//                 <span
//                   className="font-bold"
//                   style={{ fontFamily: "'Blacker Pro Display'" }}
//                 >
//                   metrics driven
//                 </span>
//               </p>
//               <div
//                 className="text-center mt-6 sm:mt-8 lg:mt-12 lg:ml-0 xl:ml-40"
//                 style={{ fontFamily: "'Blacker Pro Display'" }}
//               >
//                 <h1
//                   className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-serif text-white mb-2 sm:mb-4"
//                   style={{ fontFamily: "'Blacker Pro Display'" }}
//                 >
//                   Hi, I'm Laiba,
//                 </h1>
//                 <h2
//                   className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-serif text-white leading-tight mb-6 sm:mb-8 lg:mb-12"
//                   style={{ fontFamily: "'Blacker Pro Display'" }}
//                 >
//                   the heart behind
//                   <br />
//                   <span
//                     className="text-4xl text-[#ebe8e5e0]"
//                     style={{ fontFamily: "'Blacker Pro Display'" }}
//                   >
//                     Connect · Engage · Grow
//                   </span>
//                 </h2>
//               </div>

//               <p className="text-sm sm:text-md text-[#2B2B2B] w-full lg:w-[500px] font-semibold text-justify px-4 sm:px-0">
//                 I started this journey with one goal: to help businesses like
//                 yours thrive online and grow with ease. Social media can feel
//                 overwhelming, but that’s where I step in! From crafting unique
//                 content to managing platforms and building websites, my team and
//                 I make sure your brand connects with the right people and
//                 exceeds expectations.
//               </p>
//               <button
//                 onClick={() => {
//                   document
//                     .getElementById("section2")
//                     .scrollIntoView({ behavior: "smooth" });
//                 }}
//                 className="bg-[#704735] text-white px-4 sm:px-6 lg:px-8 py-2 sm:py-3 mt-6 sm:mt-7 text-xs sm:text-sm uppercase tracking-widest rounded-lg shadow-[5px_5px_15px_#5d392b] hover:shadow-[inset_5px_5px_15px_#5d392b,inset_-5px_-5px_15px_#855949] transition-all duration-300 ease-in-out"
//               >
//                 Learn More
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CreativeCoachLanding;
import React from "react";
import CED from "../Assets/About/About/use.jpg";

const AboutHero = () => {
  return (
    <div className="relative min-h-screen overflow-hidden -mt-24">
      {/* Full background image */}
      <div className="absolute inset-0">
        <img
          src={CED}
          alt="Background"
          className="w-full h-full object-cover grayscale"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content overlay */}
      <div className="relative min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="min-h-screen flex items-center">
            {/* Combined content container - centered on mobile, pushed right on desktop */}
            <div className="w-full flex flex-col md:flex-row md:ml-auto md:gap-72 items-center md:items-start mt-32 px-4 md:px-0">
              {/* Small image */}
              <div className="relative w-full max-w-[320px] h-[400px] md:w-96 md:h-[500px] border-4 border-white overflow-hidden flex-shrink-0 mb-8 md:mb-0">
                <img
                  src={CED}
                  alt="Profile thumbnail"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Text content */}
              <div className="text-white max-w-xl text-center md:text-left">
                <div className="space-y-0">
                  <div>
                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-2">
                      Hi, I'm Laiba,
                    </h1>
                    <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-4">
                      the heart behind
                    </h2>
                    <div className="text-2xl md:text-3xl lg:text-4xl mb-8">
                      Connect · Engage · Grow
                    </div>
                  </div>

                  <p className="text-sm md:text-md text-white max-w-lg font-semibold px-4 md:px-0">
                    I started this journey with one goal: to help businesses
                    like yours thrive online and grow with ease. Social media
                    can feel overwhelming, but that's where I step in! From
                    crafting unique content to managing platforms and building
                    websites, my team and I make sure your brand connects with
                    the right people and exceeds expectations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutHero;
